import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import Layout from "@/components/Layout";
import { LanguageProvider } from "@/lib/i18n";
import { BagProvider } from "@/context/BagContext";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductPage from "@/pages/ProductPage";
import Bag from "@/pages/Bag";
import Checkout from "@/pages/Checkout";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import SizeGuide from "@/pages/SizeGuide";
import FAQ from "@/pages/FAQ";
import ShippingPolicy from "@/pages/ShippingPolicy";
import ReturnsPolicy from "@/pages/ReturnsPolicy";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <BagProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/boutique" element={<Shop />} />
                <Route path="/piece/:slug" element={<ProductPage />} />
                <Route path="/panier" element={<Bag />} />
                <Route path="/commande" element={<Checkout />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/guide-des-tailles" element={<SizeGuide />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/livraison" element={<ShippingPolicy />} />
                <Route path="/retours" element={<ReturnsPolicy />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-center" />
        </BagProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
